import { render } from "./user-metric-grid.vue?vue&type=template&id=58791a99&scoped=true"
import script from "./user-metric-grid.vue?vue&type=script&lang=js"
export * from "./user-metric-grid.vue?vue&type=script&lang=js"

import "./user-metric-grid.vue?vue&type=style&index=0&id=58791a99&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58791a99"]])

export default __exports__